import camelcaseKeys from 'camelcase-keys'

import ApiClient from '@src/lib/api_client'
import { API } from '@src/lib/api_path'
import Club from '@src/data/club'
import SessionManager from '@src/lib/session_manager'
import { MemberProfile } from '@src/data/member-profile'

type ClubResponse = { club: Club }
type ProfileResponse = { profile: MemberProfile }

export class ClubService {
  static loadClub (store?) {
    if (SessionManager.Instance.isManager()) {
      return ClubService.getClub(store)
    } else {
      return ClubService.getClubFromProfile(store)
    }
  }

  static getClub (store) {
    const apiClient: ApiClient = new ApiClient(API.TRAINERS_API.CLUB)
    return apiClient.get<ClubResponse>()
      .then((response) => store.dispatch('setClub', new Club(camelcaseKeys(response.club, { deep: true }))))
      .catch((error) => console.error('failed to retrieve club data', error))
  }

  static getClubFromProfile (store) {
    const apiClient: ApiClient = new ApiClient(API.MEMBERS_API.PROFILE)
    return apiClient.get<ProfileResponse>()
      .then((response) => {
        store.dispatch('setProfile', new MemberProfile(camelcaseKeys(response.profile)))
        store.dispatch('setMemberForActiveWorkout', new MemberProfile(camelcaseKeys(response.profile)))
        store.dispatch('setClub', new Club(camelcaseKeys(response.profile.club, { deep: true })))
      })
      .catch((error) => console.error('failed to retrieve club data', error))
  }
}
